import { t } from "@lingui/core/macro";
import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "@warp-ds/elements/toast";

export const makeQueryClient = () => {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: () => {
				toast(t`We're having trouble loading this page. Please try again.`, {
					type: "error",
					id: "query-error",
				});
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: 5 * (60 * 1000), // 5 min
				retry: false,
			},
		},
	});
};
